import { Component, Input, OnInit } from '@angular/core';

import { TwcSwitchComponent } from '@topcon/twc-angular';

import { Property, PropertySet } from '@mirage-projects/cw-models';

import { PropertyBagService } from '../property-bag.service';

/**
 * This component is responsible to show switch property bag
 */
@Component({
    selector: 'cw-property-switch',
    templateUrl: 'property-switch.component.html',
    standalone: false,
})
export class PropertySwitchComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;
    /** Input field with the required information for this field type */
    @Input() property!: Property;

    selectedIndex = 0;
    options: any[] = [];

    constructor(private propertyBagService: PropertyBagService) {}

    ngOnInit(): void {
        this.property.value = this.propertyBagService.getValueProperty(this.propertySet, this.property);
        this.options = this.propertyBagService.getValueRange(this.propertySet, this.property);

        this.setSelectedIndex();
    }

    /**
     * Stores the selected value in the local storage
     * @param selectedElement Element selected by the user
     */
    saveSelectedOption(selectedElement: TwcSwitchComponent): void {
        this.property.value = selectedElement.selectedItem?.data.type ?? this.options[0];
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }

    private setSelectedIndex(): void {
        this.selectedIndex = this.options.indexOf(this.property.value);
    }
}
